import LegalPage from "../components/LegalPage";

const SECTIONS = [
    {
        heading: "SahiKhoj is a discovery platform",
        body: [
            "SahiKhoj is a discovery and comparison platform. The app helps users explore prices, deals, coupons and travel options across supported third-party platforms. SahiKhoj does not sell products, issue coupons, operate flights or run hotels.",
        ],
    },
    {
        heading: "Prices and availability may change",
        body: [
            "Product prices and availability shown in the app come from third-party platforms and can change at any time, sometimes without notice. The price and availability shown on the third-party platform at the time of purchase are final.",
        ],
    },
    {
        heading: "Coupons and offers may expire",
        body: [
            "Coupons, deals and offers are created and controlled by third-party merchants. They may expire, change or be withdrawn at any time, and may carry conditions set by the merchant. SahiKhoj does not guarantee that any coupon or offer will work.",
        ],
    },
    {
        heading: "Third-party information may change",
        body: [
            "Information originating from third-party platforms — including product details, travel schedules and hotel information — may be updated, corrected or removed by those platforms at any time.",
        ],
    },
    {
        heading: "Confirm before you buy or book",
        body: [
            "Always confirm the final price, availability and applicable terms on the respective third-party platform before completing a purchase or booking. Any transaction you complete is between you and the third-party platform.",
        ],
    },
    {
        heading: "Trademarks",
        body: [
            "All third-party trademarks, logos and brand names referenced within SahiKhoj belong to their respective owners. Reference to them is for identification only and does not imply any endorsement, sponsorship or affiliation.",
        ],
    },
];

const DisclaimerPage = () => (
    <LegalPage
        title="Disclaimer"
        eyebrow="SahiKhoj Legal"
        updated="July 2026"
        description="Important notes about prices, coupons, third-party platforms and trademarks referenced by SahiKhoj."
        path="/disclaimer"
        intro="A few honest notes about what SahiKhoj is — and what it is not."
        sections={SECTIONS}
        testId="disclaimer-page"
    />
);

export default DisclaimerPage;
